/** Максимальное кол-во публикаций на странице /publishing */
export const PageSize = 5;
